import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PasswordGate } from "./components/PasswordGate";
import { ChangelogScreen } from "./screens/ChangelogScreen";
import { HomeScreen } from "./screens/HomeScreen";
import { HowToPlayScreen } from "./screens/HowToPlayScreen";
import { RolesScreen } from "./screens/RolesScreen";
import { RoomShell } from "./screens/RoomShell";

const PASSWORD = (import.meta.env.VITE_TC_PASSWORD ?? "").trim();

export default function App() {
  return (
    <PasswordGate password={PASSWORD}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/how-to-play" element={<HowToPlayScreen />} />
          <Route path="/how-to-play/:script" element={<HowToPlayScreen />} />
          <Route path="/roles" element={<RolesScreen />} />
          <Route path="/roles/:script" element={<RolesScreen />} />
          <Route path="/changelog" element={<ChangelogScreen />} />
          <Route path="/room/:code" element={<RoomShell />} />
          <Route path="/join/:code" element={<RoomShell />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </PasswordGate>
  );
}
